import { API, Auth } from 'aws-amplify'

async function getMembers() {
  let myInit = {
    response: false,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    }
  }

  return API.get('mctcuser', '/users', myInit)
}

async function promoteMember(args) {
  let myInit = {
    response: false,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    body: args
  }

  return API.post('mctcuser', '/promote', myInit)
}

async function getMemberProfile(profileId) {
  let myInit = {
    response: false,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    }
  }

  return API.get('mctcuser', `/users/${profileId}`, myInit)
}

async function updateMemberProfile(data) {
  let profileId = data.username
  let myInit = {
    response: false,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    body: {
      updatedProfile: data
    }
  }

  return API.post('mctcuser', `/users/${profileId}`, myInit)
}

async function grantLifeMembership(profileId) {
  let myInit = {
    response: false,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    body: {
      profileId,
      upgradeCode: 'upgrade_membership_life'
    }
  }

  return API.post('mctcuser', '/subscription/upgrade', myInit)
}

async function deactivateMembership(profileId) {
  let myInit = {
    response: false,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    body: {
      profileId,
      changeCode: 'deactivate_membership'
    }
  }

  return API.post('mctcuser', '/subscription/deactivate', myInit)
}

async function resetMemberPwd(userid) {
  let myInit = {
    response: false,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    body: {
      userid,
      changeCode: 'reset_password'
    }
  }

  return API.post('mctcuser', `/users/${userid}/reset`, myInit)
}

async function resendAccountActivation(userid) {
  let myInit = {
    response: false,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    body: {
      userid,
      changeCode: 'resend_activation'
    }
  }

  return API.post('mctcuser', `/users/${userid}/reset`, myInit)
}

async function getCertificate(data) {
  let profileId = data.username
  let myInit = {
    response: false,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    }
  }

  return API.get('mctcuser', `/users/${profileId}/certificate`, myInit)
}

async function archiveUsers(userIds) {
  let myInit = {
    response: false,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    body: {
      userIds
    }
  }
  return API.post('backend-v2', '/users/archive', myInit)
}

export default {
  getMembers,
  promoteMember,
  getMemberProfile,
  updateMemberProfile,
  grantLifeMembership,
  deactivateMembership,
  getCertificate,
  resetMemberPwd,
  resendAccountActivation,
  archiveUsers
}
